// extracted by mini-css-extract-plugin
export default {"checkboxGroupWrap":"checkboxGroupWrap_LIRJO","horizontal":"horizontal_LIRJO","vertical":"vertical_LIRJO","start":"start_LIRJO","end":"end_LIRJO","center":"center_LIRJO"};